import { Category } from '@/entities/catalog-page/Category/ui/Category.jsx'
import './ui/Category.scss'
export default Category
